angular.module('impactx.purchaserequest').controller('ApprovalModifiedPriCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToolbarService',
    ApprovalModifiedPriCtrl]);

function ApprovalModifiedPriCtrl($scope, dataGen, $routeParams, ToolbarService) {
    var self = this;
    dataGen.getData($scope, {priId: $routeParams.id}, "/purchaserequest/viewapprovalmodified").then(function () {
        ToolbarService.setButtons([]);
    });

    this.showValue = function (index, data, valuepath) {
        if (angular.isDefined(index) && data && data.entries && valuepath)
        {
            if (index === 0)
            {
                return true;
            }
            else
            {
                return impactX.isDefined(data.entries[index], valuepath) != impactX.isDefined(data.entries[index - 1], valuepath)
            }
        }
        return false;
    };

    this.showControl = function (index, data, controlType) {
        if (angular.isDefined(index) && data && data.entries && controlType)
        {
            var setValuePath = "control." + controlType + ".set";
            var setValue = impactX.isDefined(data.entries[index], setValuePath);

            if (index === 0)
            {
                if (!setValue || setValue.length === 0)
                {
                    return false;
                }
            }
            else
            {
                var previousSetValue = impactX.isDefined(data.entries[index - 1], setValuePath);
                if ((setValue && !previousSetValue) || (!previousSetValue && setValue) || (previousSetValue && setValue && previousSetValue.length !== setValue.length)
                    || (previousSetValue && setValue && previousSetValue[0] && setValue[0] && previousSetValue[0].id !== setValue[0].id))
                {
                    return true;
                }
            }
        }
        return false;
    };

    this.showMultiControl = function (index, data, controlType) {
        if (angular.isDefined(index) && data && data.entries && controlType)
        {
            if (self.showControl(index, data, controlType))
            {
                return true;
            }
            else
            {
                var setValuePath = "control." + controlType + ".set";
                var setValue = impactX.isDefined(data.entries[index], setValuePath);
                var previousSetValue = impactX.isDefined(data.entries[index - 1], setValuePath);

                if (previousSetValue && setValue && previousSetValue.length > 0 && setValue.length > 0)
                {
                    for (var i = 0; i < previousSetValue.length; i++)
                    {
                        var id = previousSetValue[i].id;
                        var valueInCurrentList = null;
                        for (var j = 0; j < setValue.length; j++)
                        {
                            if (id === setValue[j].id)
                            {
                                valueInCurrentList = setValue[j];
                            }
                            if (valueInCurrentList === null)
                            {
                                return true;
                            }
                            else
                            {
                                if (valueInCurrentList.factor !== previousSetValue[i].factor)
                                {
                                    return true;
                                }
                            }
                        }
                    }
                }
            }
        }
        return false;
    }
}